import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';

import { generateUrl, paths } from 'shared/base';

interface Props {
  teamName: string;
}

export const QuickSyntaxHelper = ({ teamName }: Props) => {
  const syntaxPath = generateUrl({
    pathname: paths.platformDocs.searchSyntax,
    query: { team: teamName },
  });

  return (
    <Stack justifyContent="center">
      <Tooltip
        title={
          <Box>
            <Box>
              <Link
                href={syntaxPath}
                style={{ color: 'primary.main', textDecoration: 'none' }}
                target="_blank"
                variant="body2"
              >
                Open full syntax documentation
              </Link>
            </Box>
            <Divider sx={{ marginY: 0.5 }} />
            <Box>
              <b>Equality:</b> =
            </Box>
            <Box>
              <b>Comparison:</b> {`<, >, <=, >=`}
            </Box>
            <Box>
              <b>Null:</b> IS NULL, IS NOT NULL
            </Box>
            <Box>
              <b>Empty:</b> IS EMPTY, IS NOT EMPTY
            </Box>
            <Box>
              <b>Membership:</b> IN
            </Box>
            <Box>
              <b>Array/Map contains:</b> CONTAINS
            </Box>
            <Box>
              <b>Operators:</b> AND, OR
            </Box>
            <Divider sx={{ marginY: 0.5 }} />
            <Box>
              <b>Example: </b>
            </Box>
            <Box>
              {`name = "z1d.6xlarge" AND region IN (eu-west-1, us-east-1) AND tags IS
        NOT EMPTY`}
            </Box>
          </Box>
        }
      >
        <IconButton href={syntaxPath} target="_blank">
          <HelpOutlineIcon sx={{ cursor: 'pointer' }} />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};
